<template>
  <div id="BaigolfLoading" class="bg-loading-mask" v-show="show">
    <div class="bg-loading-wrp">
      <div class="bg-loading-svga" id="loadingSvga"></div>
    </div>
  </div>
</template>

<script>
  import {transformSVGA} from '@/utils';

  export default {
    name: 'loading',
    model: {
      prop: 'show',
      event: 'change',
    },
    props: {
      show: Boolean,
      // 预留属性
      text: String,
    },
    data(){
      return {
        svgaPlayer: null,
      };
    },
    mounted(){
      // 渲染loading动画
      setTimeout(() => {
        this.svgaPlayer = transformSVGA('#loadingSvga', '/static/svga/loading.svga');
      }, 100);
    },
  }
</script>

<style lang="scss" scoped>
  .bg-loading-mask{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 99999;
    background: rgba(0, 0, 0, 0.5);
  }
  .bg-loading-wrp{
    position: absolute;
    left: 50%;
    top: 50%;
    width: 120px;
    height: 120px;
    margin-left: -60px;
    margin-top: -60px;
    z-index: 100000;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
  }
  .bg-loading-svga{
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/BGLoading/BGLoading.vue